import { z } from "zod";
export const RoleSchema = z.enum(["servidor", "banco", "averbadora", "prefeitura"]);
export const LoginRequestSchema = z.object({
    identifier: z.string().min(3),
    password: z.string().min(6),
    device_id: z.string().optional(),
});
export const UserSchema = z.object({
    id: z.number().int(),
    nome: z.string(),
    role: RoleSchema,
    avatar_url: z.string().url().nullable().optional(),
});
export const AuthSuccessSchema = z.object({
    access_token: z.string(),
    refresh_token: z.string(),
    expires_in: z.number().int(),
    role: RoleSchema,
    user: UserSchema,
    /**
     * A senha usada neste login foi definida por OUTRA pessoa (hoje: o admin do
     * banco criando um operador) e ainda nao foi trocada pelo dono. A tela desvia
     * para a troca obrigatoria em vez da dashboard.
     *
     * Ausente na esmagadora maioria dos logins. Nao e' oraculo de enumeracao:
     * quem recebe este campo ja autenticou com sucesso.
     */
    senha_temporaria: z.boolean().optional(),
});
export const RefreshRequestSchema = z.object({
    refresh_token: z.string(),
});
//# sourceMappingURL=auth.js.map